﻿$(document).ready(function () {
    const $activityContainer = $('#activity_container');
    const pageSize = 10;
    let activityData = [];

    // 讀取活動資料---------------------
    function loadActivity() {
        $.ajax({
            url: '/activity/activities_json',
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                activityData = data;
                initializePagination(activityData, pageSize, displayActivities, $('#pagination_container'));  //在site.js
            },
            error: function (xhr, status, error) {
                console.error('Error loading activities:', error);
            }
        });
    }

    // 顯示活動資料---------------------
    function displayActivities(page) {
        $activityContainer.empty();
        const startIndex = (page - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, activityData.length);

        for (let i = startIndex; i < endIndex; i++) {
            const activityShowUrl = `/activity/${activityData[i].activity_id}`;
            const activityItem = `
                <div class="col-12 col-lg-6 pe-lg-3 ps-lg-3 mb-5 ytlee-activity-border-bottom">
                    <div class="ytlee-activity-item pb-3 pe-lg-4">
                        <div class="col-12 mb-2 wow fadeIn tw:aspect-video tw:overflow-hidden" data-wow-delay="0.3s">
                            <a href="${activityShowUrl}" target="_self">
                                <img src="${activityData[i].img_url}" class="tw:w-full tw:h-full tw:object-cover" alt="Activity Image">
                            </a>
                        </div>
                        <div class="col-12 mb-2 wow fadeIn" data-wow-delay="0.3s">
                            <span>發布日期：${activityData[i].date}</span>
                        </div>
                        <div class="col-12 mb-2 wow fadeIn" data-wow-delay="0.3s">
                            <h4>${activityData[i].title}</h4>
                        </div>
                        <div class="col-12 mb-2 wow fadeIn" data-wow-delay="0.3s">
                            <h5>參加對象：${activityData[i].participants}</h5>
                        </div>
                        <div class="col-12 mb-2 wow fadeIn" data-wow-delay="0.3s">
                            <h5>地點：${activityData[i].location}</h5>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center align-items-center wow fadeIn mt-auto" data-wow-delay="0.3s">
                        <a href="${activityShowUrl}" target="_self" class="btn btn-primary ytlee-btn-md fs-5">了解更多</a>
                    </div>
                </div>
            `;

            $activityContainer.append(activityItem);
        }
    }
    loadActivity();
});
